import { isEmptyText, Prismic, PrismicText } from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import React from 'react';
import { Author } from '../components/author/Author';
import { QuoteExpand } from '../components/slices/QuoteExpand';

interface IProps {
  title: Prismic.RichText;
  copy: Prismic.RichText;
  expandable_copy: Prismic.RichText;
  top_splitter: boolean;
  fields: IField[];
}

interface IField {
  image?: Prismic.Image;
  job_title: Prismic.RichText;
  name: Prismic.RichText;
}

const renderAuthorItem = ({ author }: any, i: number) => {
  return (
    <Author
      key={`${author?.name}-${i}`}
      image={author?.image}
      name={Prismic.text(author?.name)}
      title={Prismic.text(author?.job_title)}
    />
  );
};

export const QuoteExpandContainer = ({
  title,
  copy,
  expandable_copy,
  top_splitter,

  fields,
}: IProps) => {
  if (isEmptyText(copy)) {
    return null;
  }

  return (
    <Segment isArticle>
      <QuoteExpand
        cards={fields?.map(renderAuthorItem)}
        title={Prismic.text(title)}
        copy={<PrismicText value={copy} isArticle={true} />}
        topSplitter={top_splitter}
        expandableCopy={
          <PrismicText value={expandable_copy} isArticle={true} />
        }
      />
    </Segment>
  );
};
